// extracted by mini-css-extract-plugin
export default {"info":"delete-message-modal_info__H+UOv","text":"delete-message-modal_text__HFaw7","source":"delete-message-modal_source__CIBnK","button":"delete-message-modal_button__1Uo8+"};